__turbopack_context__.v({
  "placeholder": "steps-module-scss-module__1FQzJa__placeholder",
  "step": "steps-module-scss-module__1FQzJa__step",
  "step-content": "steps-module-scss-module__1FQzJa__step-content",
  "steps": "steps-module-scss-module__1FQzJa__steps",
});
